module.exports = __webpack_public_path__ + "fonts/NunitoSans-SemiBold.97020b1.ttf";